import { render, staticRenderFns } from "./InvokeApi.vue?vue&type=template&id=b6591200&scoped=true&"
import script from "./InvokeApi.vue?vue&type=script&lang=js&"
export * from "./InvokeApi.vue?vue&type=script&lang=js&"
import style0 from "./InvokeApi.vue?vue&type=style&index=0&id=b6591200&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6591200",
  null
  
)

export default component.exports